import { createContext, useContext } from 'react';

interface LayoutContextValue {
  hideSidebar: boolean;
  setHideSidebar: (v: boolean) => void;
}

export const LayoutContext = createContext<LayoutContextValue>({
  hideSidebar: false,
  setHideSidebar: () => {},
});

export const useLayout = () => useContext(LayoutContext);
